import React, { useEffect, useState } from "react";
import { Modal, Tab, Nav, Button } from "react-bootstrap";
import "./AccountDetailsModal.css";
import TauriImage from "../../TauriImage/TauriImage";
import { getAll, getRecordById } from "../../../localDB";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import CoveragePeriod from "../AccountSidebar/CoveragePeriod/CoveragePeriod";
import OpalAccountBasicInfo from "../../OpalAccountInfoDetails/OpalAccountBasicInfo/OpalAccountBasicInfo";
import OpalAccountAddressDetails from "../../OpalAccountInfoDetails/OpalAccountAddressDetails/OpalAccountAddressDetails";
import OpalAccountTerritorialConfiguration from "../../OpalAccountInfoDetails/OpalAccountTerritorialConfiguration/OpalAccountTerritorialConfiguration";
import OpalAccountCoverage from "../../OpalAccountInfoDetails/OpalAccountCoverage/OpalAccountCoverage";
import OpalAccountCategorization from "../../OpalAccountInfoDetails/OpalAccountCategorization/OpalAccountCategorization";
import appUrl from '../../../appURL.json';

const AccountDetailsModal = ({ show, onHide, accID }) => {
    const [activeMainTab, setActiveMainTab] = useState("account");
    const [activeAccountInfoTab, setActiveAccountInfoTab] = useState("BASIC INFORMATION");
    const [loadingCoverageHistory, setLoadingCoverageHistory] = useState(false);
    const [loadingAccountInfo, setLoadingAccountInfo] = useState(false);
    const [coverageHistory, setCoverageHistory] = useState([]);
    const [accountInfo, setAccountInfo] = useState(null);

    const fetchCoverageHistory = async (accID) => {
        setLoadingCoverageHistory(true);
        try {
            const sessions = await getAll("session");
            const account = await getRecordById("customer", accID);
            const sessionsFiltered = sessions.filter((a) => a.AccountID === accID);

            const groupedByCycle = sessionsFiltered.reduce((acc, session) => {
                if (!acc[session.CyclePeriodID]) {
                    acc[session.CyclePeriodID] = []
                }

                acc[session.CyclePeriodID].push({
                    ID: session.ID,
                    Date: session.SessionDate,
                    Status: session.Status,
                    Joint: session.Joint,
                    Account: account.Name
                });
                return acc;
            }, {});

            const result = await Promise.all(
                Object.entries(groupedByCycle).map(async ([cycleId, sessionList]) => {
                    const cycle = await getRecordById("Cycle", Number(cycleId));
                    return {
                        Cycle: {
                            Code: cycle.Code,
                            Description: cycle.Description
                        },
                        Session: sessionList
                    };
                })
            );

            setCoverageHistory(result);

        } catch (err) {
            console.log(err)
        } finally {
            setLoadingCoverageHistory(false);
        }
    }

    const fetchAccountInfo = async (accID) => {
        setLoadingAccountInfo(true);
        try {
            const token = localStorage.getItem('token');
            const devId = localStorage.getItem('devId');
            const response = await fetch(`${appUrl.API_GetAccountDetails}/${accID}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                }
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();
            setAccountInfo(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingAccountInfo(false);
        }
    };

    const handleEdit = (data) => {
    };

    useEffect(() => {
        fetchAccountInfo(accID);
        fetchCoverageHistory(accID);
    }, [accID])

    return (
        <Modal
            className="account-details-modal"
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header>
                <div className="modal-title">ACCOUNT DETAILS</div>
                <TauriImage
                    localImage={"/Images/basil--cross-outline.svg"}
                    alt="close"
                    onClick={onHide}
                    className="cursor-pointer"
                />
            </Modal.Header>

            <Modal.Body>
                <Tab.Container activeKey={activeMainTab} onSelect={(k) => setActiveMainTab(k)}>
                    {/* Main Tabs */}
                    <Nav variant="tabs" className="opal-account-main-tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="account">ACCOUNT INFO</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="coverage">COVERAGE</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <Tab.Content className="opal-account-content">
                        {/* Account Info Tab */}
                        <Tab.Pane eventKey="account">
                            <div className="tabs-container d-flex py-3">
                                {/* Sidebar Tabs */}
                                <Nav
                                    variant="pills"
                                    className="flex-column account-sub-tabs"
                                    activeKey={activeAccountInfoTab}
                                    onSelect={(k) => setActiveAccountInfoTab(k)}
                                >
                                    <Nav.Item><Nav.Link eventKey="BASIC INFORMATION">BASIC INFORMATION</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="ADDRESS DETAILS">ADDRESS DETAILS</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="TERRITORIAL CONFIGURATION">TERRITORIAL CONFIGURATION</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="COVERAGE">COVERAGE</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="CATEGORIZATION">CATEGORIZATION</Nav.Link></Nav.Item>
                                </Nav>

                                {/* Tab Content */}
                                <div className="tab-content-container px-4 flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start">
                                        {loadingAccountInfo ? (
                                            <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                                        ) : (
                                            <>
                                                {
                                                    activeAccountInfoTab === "BASIC INFORMATION" && (
                                                        <div>
                                                            <OpalAccountBasicInfo data={accountInfo?.basicInfo} />
                                                            <Button
                                                                className="btn-updateDetails d-flex align-items-center mt-2"
                                                                onClick={() => handleEdit("BASIC INFORMATION", accountInfo?.basicInfo)}
                                                            >
                                                                <TauriImage localImage={"/Images/bxs--edit.svg"} alt="edit" color={"#1D5D9B"} className={"me-2"} />
                                                                <span>Update</span>
                                                            </Button>
                                                        </div>
                                                    )
                                                }

                                                {activeAccountInfoTab === "ADDRESS DETAILS" && (
                                                    <div>
                                                        <OpalAccountAddressDetails data={accountInfo?.addressDetails} />
                                                        <Button
                                                            className="btn-updateDetails d-flex align-items-center mt-2"
                                                            onClick={() => handleEdit("ADDRESS DETAILS", accountInfo?.addressDetails)}
                                                        >
                                                            <TauriImage localImage={"/Images/bxs--edit.svg"} alt="edit" color={"#1D5D9B"} className={"me-2"} />
                                                            <span>Update</span>
                                                        </Button>
                                                    </div>
                                                )}

                                                {activeAccountInfoTab === "TERRITORIAL CONFIGURATION" && (
                                                    <div>
                                                        <OpalAccountTerritorialConfiguration data={accountInfo?.territorialConfig} />
                                                    </div>
                                                )}

                                                {activeAccountInfoTab === "COVERAGE" && (
                                                    <div>
                                                        <OpalAccountCoverage data={accountInfo?.coverage} />
                                                        <Button
                                                            className="btn-updateDetails d-flex align-items-center mt-2"
                                                            onClick={() => handleEdit("COVERAGE", accountInfo?.coverage)}
                                                        >
                                                            <TauriImage localImage={"/Images/bxs--edit.svg"} alt="edit" color={"#1D5D9B"} className={"me-2"} />
                                                            <span>Update</span>
                                                        </Button>
                                                    </div>
                                                )}

                                                {activeAccountInfoTab === "CATEGORIZATION" && (
                                                    <div>
                                                        <OpalAccountCategorization data={accountInfo?.categorization} />
                                                        <Button
                                                            className="btn-updateDetails d-flex align-items-center mt-2"
                                                            onClick={() => handleEdit("CATEGORIZATION", accountInfo?.categorization)}
                                                        >
                                                            <TauriImage localImage={"/Images/bxs--edit.svg"} alt="edit" color={"#1D5D9B"} className={"me-2"} />
                                                            <span>Update</span>
                                                        </Button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Tab.Pane>

                        {/* Coverage Tab */}
                        <Tab.Pane eventKey="coverage">
                            {loadingCoverageHistory ?
                                <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" /> :
                                <CoveragePeriod data={coverageHistory} />
                            }
                        </Tab.Pane>

                    </Tab.Content>
                </Tab.Container>
            </Modal.Body>

        </Modal>
    );
};

export default AccountDetailsModal;
